// Copyright © 2021 Move Closer
import { computed, defineComponent } from '@vue/composition-api';
import { abstractNavItemProps, useNavItem } from '../../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const BootstrapNavItem = defineComponent({
    name: 'BootstrapNavItem',
    props: abstractNavItemProps,
    emits: ['click'],
    setup(props) {
        const { innerClassList, innerId } = useNavItem(props);
        const bindings = computed(() => ({
            'aria-controls': props.id,
            'aria-selected': props.active ? 'true' : 'false',
            class: innerClassList.value,
            disabled: props.disabled,
            id: innerId.value,
            role: 'tab'
        }));
        return { bindings };
    },
    template: `
    <component :is="tag" v-bind="bindings" @click="$emit('click')">
      {{ label }}
    </component>
  `
});
